import React from 'react';
import PropTypes from 'prop-types';
import ensureAbsoluteUrl from 'utils/urlHelpers';

/**
 * DisclaimerText component.
 * Render disclaimer text with optional embedded link.
 * @param {object} props - config
 * @param {string|object} props.config - Disclaimer configuration (string or {text, linkText, linkUrl})
 * @returns {React.ReactElement|null} - Disclaimer text with optional link
 */
const DisclaimerText = ({ config }) => {
  if (!config) return null;

  if (typeof config === 'string') {
    return <>{config}</>;
  }

  const { text, linkText, linkUrl } = config;

  if (!text || !linkText || !linkUrl) {
    return <>{text || null}</>;
  }

  const index = text.indexOf(linkText);

  if (index === -1) {
    return <>{text}</>;
  }

  const before = text.slice(0, index);
  const after = text.slice(index + linkText.length);

  return (
    <>
      {before}
      <a href={ensureAbsoluteUrl(linkUrl)} target="_blank" rel="noopener noreferrer">
        {linkText}
      </a>
      {after}
    </>
  );
};

DisclaimerText.propTypes = {
  config: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      text: PropTypes.string,
      linkText: PropTypes.string,
      linkUrl: PropTypes.string,
    }),
  ]),
};

DisclaimerText.defaultProps = {
  config: null,
};

export default DisclaimerText;
